<template lang='pug'>
  include /mixins
  div
    transition(name='fade')
      +b.fake-sidebar-load(
        v-if='loading'
      )
        ui-loader
    ui-accordion(
      :init='false',
      :full-height='true'
    )
      template(#default='{ activeState, toggleActive, collapse,  style: { icon, myHeight }, isDesktop, ...other }')
        +b.tt-accordion--bordered-till-xl(
          :class='{"tt-accordion--is-open": activeState}',
        )
          ui-click-outside(:do='collapse')
            div
              +e.question.is-disable-xl(
                :class='{"is-small": needSorting}'
                @click='$modal.show("filters-modal");',
              )
                +e.icon.mdi.I(:class='activeState ? "mdi-minus" : "mdi-plus"')
                +b.filter-title
                  +b.ds-caption--size_lg.--medium.--height_2xs.P.tt-space_mr--2(
                  )
                    span.icon-filter_n
                  +b.ds-caption--size_sm.--medium.P {{ _('Фильтры') }}
                portal-target(name='sorting')
              template(
              )
                +b.filter-title-wrap.is-visible-xl
                  +b.g-row--justify_between.--align_center
                    +b.g-cell.g-cols
                      +b.filter-title
                        +b.ds-caption--size_lg.--medium.--height_2xs.P.tt-space_mr--2
                          span.icon-filter_n
                        +b.ds-caption--size_sm.--medium.P {{ _('Фільтри') }}
                    +b.g-cell.g-cols
                      +b.tt-link.--variant_start.--text-8.--weight_semibold.--size_sm.SPAN(
                        @click.prevent='handleInputFilter({})'
                      ) {{ _('Очистить фильтр') }}

              +e.description(
                :style='{maxHeight: myHeight}',
                :class='{"isFullMaxHeight": isDesktop}'
              )
                +e.content--no-pa
                  filter-ui(
                    :disabled="loading"
                    :value="prepared"
                    :available="availableMap"
                    :base-url='baseUrl'
                    :filters="filters"
                    :need-sorting='needSorting'
                    :need-search='needSearch'
                    :need-title='needTitle'
                    :pagination='pagination'
                    :prices='prices'
                    :sortlist='sortlist'
                    @input="handleInputFilter",
                    @category-hack='$emit("category-hack", $event)'
                    :isDesktop='isDesktop',
                    :label='label',
                    :isStoreCatalog='isStoreCatalog'
                    :tabs='tabs'
                  )

</template>

<script>
import ControllerMixin from '@app/Filters/mixins/ControllerMixin'

export default {
  mixins: [ControllerMixin],
}

</script>
